"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableComponent = exports.TOTAL_CELL_PADDING = void 0;
var tslib_1 = require("tslib");
var utils_1 = require("../../../utils");
var React = require("react");
var answers_lib_1 = require("@wix/answers-lib");
exports.TOTAL_CELL_PADDING = 50;
var TableComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TableComponent, _super);
    function TableComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getColWidthStyle = function (col, overridenColumnWidths) {
            return { width: overridenColumnWidths[col] - exports.TOTAL_CELL_PADDING };
        };
        return _this;
    }
    TableComponent.prototype.renderTableRow = function (row, idx) {
        var rowComp = row.map(function (cellContent, rowIndex) {
            return React.createElement("td", { key: rowIndex, className: 'table-cell' },
                React.createElement(utils_1.RenderHtml, { html: cellContent, className: 'rendered-html' }));
        });
        return (React.createElement("tr", { key: idx, className: 'table-row content-row' }, rowComp));
    };
    TableComponent.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var headings = props.value.headings;
        var cells = props.value.cells;
        var widths = props.value.columnWidths;
        var tableHeading = headings.map(function (heading, idx) { return (React.createElement("th", { key: idx, style: widths ? _this.getColWidthStyle(idx, widths) : undefined, className: 'table-cell heading-cell' },
            React.createElement(utils_1.RenderHtml, { html: heading, className: 'rendered-html' }))); });
        var tableWrapperClasses = answers_lib_1.classNames([
            'table-wrapper',
            { 'overriden-width': !!widths }
        ]);
        return (React.createElement("div", { className: answers_lib_1.classNames('component', 'table-component', this.props.direction), "data-component-type": 'table' },
            React.createElement("div", { className: tableWrapperClasses },
                React.createElement("table", null,
                    React.createElement("thead", null,
                        React.createElement("tr", { className: 'table-row heading-row' }, tableHeading)),
                    React.createElement("tbody", null, cells.map(function (row, idx) { return _this.renderTableRow(row, idx); }))))));
    };
    return TableComponent;
}(React.Component));
exports.TableComponent = TableComponent;
//# sourceMappingURL=table-component.comp.js.map